import { RootState } from 'data/root.reducers';
import { CollectionFunctionGroup } from './collectionFunctionGroup.types';

export const getCollectionFunctionGroupList = (state: RootState): CollectionFunctionGroup[] =>
  state.collectionFunctionGroup.entities;
export const getCollectionFunctionGroup = (state: RootState): CollectionFunctionGroup | null =>
  state.collectionFunctionGroup.single;
export const getSelectedCollectionFunctionGroup = (state: RootState): CollectionFunctionGroup[] =>
  state.collectionFunctionGroup.selected;
export const getCollectionFunctionGroupCreatedId = (state: RootState): string | null =>
  state.collectionFunctionGroup.createdId;

export const isCollectionFunctionGroupCreatePopupOpen = (state: RootState): boolean =>
  state.collectionFunctionGroup.ui.isCreatePopupOpen;
export const isCollectionFunctionGroupEditPopupOpen = (state: RootState): boolean =>
  state.collectionFunctionGroup.ui.isEditPopupOpen;
export const isCollectionFunctionGroupLoading = (state: RootState): boolean =>
  state.collectionFunctionGroup.ui.isLoading;
